import API from '../../../../../services/api';

export const API_VENTAS = {
    getVentas: async (archivado = false, page = null, search = null) => {
        const archived = '?archivado=' + archivado;
        const pagination = page !== null ? '&page=' + page : '';
        const searcher = search !== null ? '&' + search : '';
        return await API.get('/ventas' + archived + pagination + searcher).then(res => res.data);
    },
    getVentasPendientes: async() => {
        return await API.get('/ventas/pendientes').then(res => res.data);
    },
    getVentaCompleta: async (idVenta) => {
        return API.get('/ventas/' + idVenta + '/completa').then(res => res.data);
    },
    newVenta: async (venta) => {
        return API.post('/ventas', venta).then(res => res.data);
    },
    uploadProviderInvoice: async (venta, ventaId) => {
        return API.post('/ventas/' + ventaId + '/upload', venta).then(res => res.data);
    },
    confirmPiezas: async (data) => {
        return API.post(`/ventas/${data.venta_id}/confirm`, data).then(res => res.data);
    },
    downloadProviderInvoice: async (filename) => {
        return API.get('/ventas/' + filename + '/download', {responseType: 'arraybuffer'}).then(res => res.data);
    },
    enviarEmailFormularioIncidencia: async (ventaId) => {
        return API.post('/ventas/' + ventaId + '/formulario-incidencia').then(res => res.data);
    },
    updateVenta: async (venta) => {
        return API.put('/ventas/' + venta.id, venta).then(res => res.data);
    },
    enviarEmailRecogeCliente: async (presupuestoNum) => {
        return API.post('/almacen/entity/email-recoge-cliente', {presupuestoNum}).then(res => res.data);
    }
}